export enum LiburEnum {
    CUTI_BERSAMA = "cuti_bersama",
    LIBUR= "libur",
    SETENGAH_HARI= "setengah_hari",
}
